<web-appointment-detail [appointment]="appointment" (closeClick)="closeClicked()" mat-dialog-content></web-appointment-detail>
